<script>
import Fuse from 'fuse.js';
export default {
  components: {},
  props: {
    square: {
      type: Boolean,
      required: false,
    },
    dark: {
      type: Boolean,
      required: false,
    },
    width: {
      type: String,
      required: false,
      default: null,
    },
    message: {
      type: String,
      required: false,
      default: null,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    hasCustomIcon: {
      type: Boolean,
      required: false,
    },
    options: {
      type: Object,
      required: false,
      default: () => {},
    },
    list: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    fuse() {
      // Create a new Fuse search  instance
      const fuse = new Fuse(this.list, {
        ...this.options,
        includeScore: true,
        isCaseSensitive: false,
      });
      return fuse;
    },
  },
  created() {},
  methods: {
    filterItems(val) {
      if (val.length > 0) {
        const results = this.fuse.search(val);
        const items = results.map((result) => result.item);
        this.$emit('filter-results', items);
      } else {
        this.$emit('filter-results', this.list);
      }
    },
    handleCommandDelete(evt) {
      if (
        (evt.key === 'Backspace' && evt.metaKey) ||
        (evt.key === 'Backspace' && evt.ctrlKey)
      ) {
        if (
          this.$refs &&
          this.$refs.searchInput &&
          this.$refs.searchInput.$el &&
          this.$refs.searchInput.$el.firstChild
        ) {
          this.$refs.searchInput.$el.firstChild.value = '';
        }
        this.$emit('retry-filter-items', evt.target.value.toLowerCase());
      }
    },
  },
};
</script>

<template>
  <div :class="['search-input-wrapper', { square: square, dark: dark }, width]">
    <div class="input-icon-wrapper icon-left">
      <BaseIcon name="search" v-if="!hasCustomIcon" />
      <BaseInputText
        ref="searchInput"
        name="type"
        placeholder="Filter by Name"
        @focus="$emit('focus-filter-input')"
        @focusout="(e) => $emit('focusout-filter-input', e)"
        @keyup="filterItems($event.target.value)"
        @keydown="handleCommandDelete($event)"
        @keyup.delete="
          $emit('retry-filter-items', $event.target.value.toLowerCase())
        "
        :value="value"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.search-input-wrapper {
  width: 40.86%;

  .input-with-label {
    &:focus {
      border: unset;
      outline: unset;
    }
  }

  .input-icon-wrapper {
    &:focus {
      border: unset;
      outline: unset;
    }

    margin-bottom: 0;

    // stylelint-disable selector-pseudo-element-no-unknown
    ::v-deep .input {
      background-color: white;
      border-radius: $size-input-border-radius;
      &:focus {
        outline: unset;
      }
    }
  }

  &.dark {
    .input-icon-wrapper {
      ::v-deep .input {
        background-color: $color-off-white;
      }
    }
  }

  &.square {
    .input-icon-wrapper {
      ::v-deep .input {
        border: 1px solid gray;
        border-radius: 38px;
      }
    }
  }

  &.full {
    width: 100%;
  }

  &:focus {
    border: unset;
    outline: unset;
  }
}
</style>
